import { Avatar, Typography } from 'antd';
import React, { useState } from 'react';
import { showShortName } from '@/shared/helpers/short-name.helper';
import { Dynamics } from '@/services/dynamics/dynamics';
import { EEntity } from '@/services/dynamics/enums/entity.enum';
import { getEntityCrmIcon } from '@/services/dynamics/helpers/get-small-crm-icon.helper';
import { MessageIcon } from '@/components/MessageIcon/MessageIcon';
import './AccountInfo.scss';

const { Text } = Typography;

export interface AccountInfoProps {
  id: string;
  fullName: string;
  phone: string;
  entity: EEntity;
  size?: number;
  searchIsActive?: boolean;
}

export function AccountInfo(props: AccountInfoProps) {
  const size = props.size || 64;
  const [opening, setOpening] = useState(false);

  const openEntity = async (): Promise<void> => {
    if (opening) {
      return;
    }

    if (!props.id || !props.entity) {
      return;
    }

    setOpening(true);
    await Dynamics.openEntity(props.id, props.entity);
    setOpening(false);
  };

  const getClasses = () => {
    if (!props?.id) {
      return 'avatar__icon';
    }

    return 'avatar__icon clickable';
  };

  const getFullName = (fullName: string): string => {
    if (!fullName) {
      return 'Unknown entity';
    }

    return fullName.toLowerCase() === 'unknown entity' ? 'Unknown' : fullName;
  };

  const smallEntity = getEntityCrmIcon(props?.entity);

  return (
    <div className="account-info">
      <div className="account-info__avatar" onClick={openEntity}>
        <Avatar className={getClasses()} size={size} alt="Avatar">
          {showShortName(props.fullName)}
        </Avatar>
        {smallEntity && (
          <MessageIcon className="small-entity-icon" svgUrl={smallEntity} />
        )}
      </div>
      <div className="desc">
        <Text ellipsis={{ tooltip: props.fullName }} className="full-name">
          {props.searchIsActive
            ? 'Searching for contact...'
            : getFullName(props.fullName)}
        </Text>
        {!props.searchIsActive && (
          <Text ellipsis={{ tooltip: props.phone }} className="back-text">
            {props.phone}
          </Text>
        )}
      </div>
    </div>
  );
}
